import React, { useState, useCallback } from 'react';
import styles from './TutorialShareButtons.module.css';
import {
	shareWhatsApp,
	shareTelegram,
	shareMessenger,
	shareNative,
} from '../../utils/share';
import WhatsAppIcon from './icons/WhatsAppIcon';
import TelegramIcon from './icons/TelegramIcon';
import MessengerIcon from './icons/MessengerIcon';
import ExternalLinkIcon from './icons/ExternalLinkIcon';

function stopGesture(e) {
	e.stopPropagation();
}

export default function TutorialShareButtons() {
	const [feedback, setFeedback] = useState('');

	const showFeedback = useCallback((message) => {
		setFeedback(message);
		window.setTimeout(() => setFeedback(''), 2400);
	}, []);

	const handleWhatsApp = useCallback((e) => {
		stopGesture(e);
		shareWhatsApp();
	}, []);

	const handleTelegram = useCallback((e) => {
		stopGesture(e);
		shareTelegram();
	}, []);

	const handleMessenger = useCallback((e) => {
		stopGesture(e);
		shareMessenger();
	}, []);

	const handleNative = useCallback(async (e) => {
		stopGesture(e);
		try {
			const result = await shareNative();
			if (result === 'shared') showFeedback('Listo para compartir');
			else if (result === 'copied') showFeedback('Enlace copiado al portapapeles');
			else showFeedback('No se pudo compartir');
		} catch (err) {
			if (err?.name !== 'AbortError') showFeedback('No se pudo compartir');
		}
	}, [showFeedback]);

	return (
		<div
			className={styles.wrap}
			onPointerDown={stopGesture}
			onClick={stopGesture}
		>
			<p className={styles.label}>Comparte la app</p>
			<div className={styles.row}>
				<button
					type="button"
					className={`${styles.btn} ${styles.whatsapp}`}
					onClick={handleWhatsApp}
					aria-label="Compartir por WhatsApp"
				>
					<WhatsAppIcon className={styles.whatsappIcon} />
					<span className={styles.btnText}>WhatsApp</span>
				</button>
				<button
					type="button"
					className={`${styles.btn} ${styles.telegram}`}
					onClick={handleTelegram}
					aria-label="Compartir por Telegram"
				>
					<TelegramIcon className={styles.telegramIcon} />
					<span className={styles.btnText}>Telegram</span>
				</button>
				<button
					type="button"
					className={`${styles.btn} ${styles.messenger}`}
					onClick={handleMessenger}
					aria-label="Compartir por Messenger"
				>
					<MessengerIcon className={styles.messengerIcon} />
					<span className={styles.btnText}>Messenger</span>
				</button>
				<button
					type="button"
					className={`${styles.btn} ${styles.native}`}
					onClick={handleNative}
					aria-label="Más opciones para compartir"
				>
					<ExternalLinkIcon className={styles.nativeIcon} />
					<span className={styles.btnText}>Más opciones</span>
				</button>
			</div>
			{feedback && (
				<p className={styles.feedback} role="status">{feedback}</p>
			)}
		</div>
	);
}
